import Message from "../../message";
import router from "@/router";
import {useMainStore} from "@/store";

export default class MaintenanceStart extends Message
{
    handle()
    {
        useMainStore().SET_MAINTENANCE(this.message);
        router.push({name: 'maintenance'}).then(() => {});
    }
}
